/* eslint-disable no-console */
import { createAuthHeaders } from '../utils/api-headers';

interface IAuthActivityResponse {
  success: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
  error?: string;
}

export const authService = {
  async fetchUserAuthActivity(jwt: string): Promise<IAuthActivityResponse> {
    const headers = createAuthHeaders(jwt);

    try {
      const response = await fetch('/customer/account/v1/activity', {
        method: 'GET',
        headers,
      });

      if (response.ok) {
        const data = await response.json();
        return { success: true, data };
      }
      return { success: false, error: response.statusText };
    } catch (error) {
      console.error('Failed to fetch user auth activity:', error);
      return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
    }
  }
};
